import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify)

export const defaultConfig = {
  theme: {
    themes: {
      light: {
        primary: '#46a9d4',
        secondary: '#D9452B',
        accent: '#1c6992',
        error: '#FF5152',
        warning: '#fca513',
        info: '#02a4d3',
        success: '#c5e17a'
      }
    },
    options: {
      customProperties: true
    }
  },
  icons: {
    iconfont: 'md'
  }
}

export function mergeConfig (theme) {
  defaultConfig.theme.themes.light = theme.theme
  defaultConfig.theme.themes.dark = theme.theme
  return defaultConfig
}
export default (config = defaultConfig) => new Vuetify(config)
